import Cookies from 'js-cookie'

const TOKEN_KEY = 'olx_monitor_token'

export const tokenStorage = {
  get(): string | null {
    return Cookies.get(TOKEN_KEY) ?? null
  },
  set(token: string): void {
    Cookies.set(TOKEN_KEY, token, {
      expires: 7,
      sameSite: 'Lax',
      secure: window.location.protocol === 'https:',
    })
  },
  clear(): void {
    Cookies.remove(TOKEN_KEY)
  },
}
